import { render, staticRenderFns } from "./sk-cards.vue?vue&type=template&id=3037d912"
import script from "./sk-cards.vue?vue&type=script&lang=js"
export * from "./sk-cards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports